module.exports = __webpack_public_path__ + "static/moultriebigsign-848806155388092693e0e3fe26ab232a.jpg";